
<template lang="pug">
div
  Navbar
  main.content(role="main")
    router-view
    .row.padded-bottom.padded.overview
      .col-7
        h2 Try it FREE
        p.py-4 Sign-up today and start integrating your application to our API and SDK.
        router-link.btn.btn-white(v-if="!$store.getters.isLoggedIn", to="/auth" tag="button") Try Now
        router-link.btn.btn-white(v-else, :to="$store.getters.redirectRoute" tag="button") Try Now
      .col-5
        img.lower-banner(
          src="@/assets/images/image-lower-banner.png",
          alt="overview"
        )
    footer.d-flex.flex-column
      .d-flex.flex-row.footer-top.padded
        .col-2.d-flex.flex-column
          a(href="/") Home
          a(href="") About Us
        .col-2.d-flex.flex-column
          a(href="") Team
          a(href="") Partners
        .col-4.d-flex.flex-column
          a(href="") Privacy Policy
          a(href="") Terms & Condition
        .col-4.d-flex.flex-column
          span Follow Us to Stay Up to Date
          .d-flex.flex-row
            .social-btn.py-2.mr-2
              img(
                height="80%",
                src="@/assets/images/icon-twitter.png",
                alt="twitter"
              )
            .social-btn.py-2.mr-2
              img(
                height="80%",
                src="@/assets/images/icon-linkedin.png",
                alt="linkedin"
              )
            .social-btn.py-2.mr-2
              img(
                height="80%",
                src="@/assets/images/icon-facebook.png",
                alt="facebook"
              )
            .social-btn.py-2.mr-2
              img(
                height="80%",
                src="@/assets/images/icon-youtube.png",
                alt="youtube"
              )
      .padded.py-2
        small Copyright &copy;2020 Xendity. All Rights Reserved.
    //- Footer
</template>>

<script>
import Navbar from "@/components/Navbars/Index";
import Footer from "@/components/Footers/Index";

import patternVue from "@/assets/img/pattern_vue.png";
import componentBtn from "@/assets/img/component-btn.png";
import componentProfileCard from "@/assets/img/component-profile-card.png";
import componentInfoCard from "@/assets/img/component-info-card.png";
import componentInfo2 from "@/assets/img/component-info-2.png";
import componentMenu from "@/assets/img/component-menu.png";
import componentBtnPink from "@/assets/img/component-btn-pink.png";
import documentation from "@/assets/img/documentation.png";
import login from "@/assets/img/login.jpg";
import profile from "@/assets/img/profile.jpg";
import landing from "@/assets/img/landing.jpg";

export default {
  data() {
    return {
      patternVue,
      componentBtn,
      componentProfileCard,
      componentInfoCard,
      componentInfo2,
      componentMenu,
      componentBtnPink,
      documentation,
      login,
      profile,
      landing,
    };
  },
  components: {
    Navbar,
    Footer,
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/website.scss";
</style>